/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import invariant from 'react-utils/invariant';
import PropTypes from 'prop-types';
import getPDFPageState from '../../selectors/getPDFPageState';
import LayerDecorator from './LayerDecorator';
import TextLayerDecorator from './TextLayerDecorator';
import AnnotationLayerDecorator from './AnnotationLayerDecorator';
import PDFPageImage from './PDFPageImage';

const getOriginalSizeScale = () => window.devicePixelRatio;

const PDFImageWithLayers = LayerDecorator(TextLayerDecorator, AnnotationLayerDecorator)(PDFPageImage);
export default class PDFPage extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      pageObject: null,
      viewport: null,
      prevPageIndex: this.props.pageIndex,
      prevPdf: this.props.pdf,
      prevZoom: this.props.zoom
    };

    this.buildPageObject = () => {
      const {
        pdf
      } = this.props;
      const {
        pageNumber
      } = getPDFPageState(this.props);
      pdf.getPage(pageNumber).then(pageObject => {
        this.setState({
          pageObject
        });
      });
    };

    this.buildViewport = () => {
      const {
        zoom
      } = this.props;
      const {
        pageObject
      } = this.state;
      invariant(pageObject !== null, 'PDFPage: buildViewport is being called too early. pageObject is null while trying to build viewport');
      const containerWidth = this.page.offsetWidth;
      const containerHeight = this.page.offsetHeight;
      const retinaScale = getOriginalSizeScale();
      const originalSizeViewport = pageObject.getViewport({
        scale: 1.0
      });
      const originalSizeWidth = originalSizeViewport.width;
      const originalSizeHeight = originalSizeViewport.height;
      const xScale = retinaScale * containerWidth / originalSizeWidth;
      const yScale = retinaScale * containerHeight / originalSizeHeight;
      const isOriginalScreenHeightLargerThanContainerHeight = xScale * originalSizeHeight > containerHeight;
      const baseScale = isOriginalScreenHeightLargerThanContainerHeight ? yScale : xScale;
      const adjustedViewport = pageObject.getViewport({
        scale: baseScale * zoom
      });
      adjustedViewport.retinaScale = retinaScale;
      this.setState({
        viewport: adjustedViewport
      });
    };

    this.renderPageContents = () => {
      const {
        pageIndex
      } = this.props;
      const {
        pageObject,
        viewport
      } = this.state;

      if (viewport === null) {
        return null;
      }

      return /*#__PURE__*/_jsx(PDFImageWithLayers, {
        pageObject: pageObject,
        viewport: viewport,
        pageIndex: pageIndex
      });
    };
  }

  static getDerivedStateFromProps(props, state) {
    let shouldUpdateState = false;
    const stateUpdate = {};
    const {
      pageIndex,
      pdf,
      zoom
    } = props;

    if (pageIndex !== state.prevPageIndex || pdf !== state.prevPdf) {
      stateUpdate.prevPageIndex = pageIndex;
      stateUpdate.prevPdf = pdf;
      stateUpdate.pageObject = null;
      stateUpdate.viewport = null;
      shouldUpdateState = true;
    }

    if (zoom !== state.prevZoom) {
      stateUpdate.prevZoom = zoom;
      stateUpdate.viewport = null;
      shouldUpdateState = true;
    }

    return shouldUpdateState ? stateUpdate : null;
  }

  componentDidMount() {
    this.buildPageObject();
    window.addEventListener('resize', this.buildViewport);
  }

  componentDidUpdate() {
    const {
      pageObject,
      viewport
    } = this.state;

    if (pageObject === null) {
      this.buildPageObject();
      return;
    }

    if (viewport === null) {
      this.buildViewport();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.buildViewport);
  }

  render() {
    const {
      pageObject
    } = this.state;

    if (pageObject === null) {
      return null;
    }

    return /*#__PURE__*/_jsx("div", {
      className: "pdf-page",
      ref: c => this.page = c,
      children: this.renderPageContents()
    });
  }

}
PDFPage.propTypes = {
  pdf: PropTypes.object.isRequired,
  pageIndex: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired
};